angular.module('bbl.module.plans-billings.routing', [])
  .config(['$routeProvider', plansBillingsRoutingSetup]);

function plansBillingsRoutingSetup($routeProvider) {
  $routeProvider.when('/plans-billing', freeBillingsRoute)
    .when('/plans-billing/india', indiaPlanRoute)
    .when('/plans-billing/:customPlan', customPlanRoute)
    .when('/plans-billing-update', updateBillingsRoute);
}

var getUser = ["Auth", function(Auth) {
  return Auth.getUserInfo();
}];

var getComp = ["Auth", function(Auth) {
  return Auth.getCompanyInfo();
}];

var getPerm = ["Auth", "$q", function(Auth, $q) {
  return Auth.getPermission().then(function(response) {
    if(response.data.permission_level !== 3) {
      return $q.reject({ authenticated: false });
    }

    return response.data.permission_level;
  });
}];

var isFreeUser = ["Auth", "$q", function(Auth, $q) {
  return Auth.getUserInfo().then(function(userInfo) {
    if (parseInt(userInfo.plan.price) > 0 || userInfo.plan.price === undefined) {
      return $q.reject({ free_user: false });
    }
  });
}];

var resolve = {
  permissions: getPerm,
  userInfo: getUser,
  company: getComp,
  customPlan: function(){}
};

var indiaPlan = {
  id: 33,
  description: "India",
  max_lines: 1,
  name: "India",
  overage_price: "5",
  price: "28.00"
};

var freeBillingsRoute = {
  templateUrl: 'plans-billing-template.html',
  controller: 'PlansBillingsController',
  resolve: angular.extend({}, resolve, { isFreeUser: isFreeUser })
};

var indiaPlanRoute = {
  templateUrl: 'plans-billing-india-template.html',
  controller: 'PlansBillingsController',
  resolve: angular.extend({}, resolve, { isFreeUser: isFreeUser }, {
    customPlan: function() {return indiaPlan;}
  })
};

var customPlanRoute = {
  templateUrl: 'plans-billing-india-template.html',
  controller: 'PlansBillingsController',
  resolve: angular.extend({}, resolve, { isFreeUser: isFreeUser }, {
    customPlan: ["$q", "Plan", function() {
      return $q(function(resolve, reject) {
        // try getting prod plan 74, or dev plan 29, or dev plan 72
        Plan.getPlanInfo(74)
          .catch(Plan.getPlanInfo.bind(Plan, 29))
          .catch(Plan.getPlanInfo.bind(Plan, 72))
          .then(resolve)
          .catch(reject);
      });
    }]
  })
};

var updateBillingsRoute = {
  templateUrl: 'update-data-template.html',
  controller: 'PlansBillingsController',
  resolve: angular.extend({}, resolve, {
    isPaidUser: ["Auth", "$q", function(Auth, $q) {
      return Auth.getUserInfo().then(function(userInfo) {
        if (parseInt(userInfo.plan.price) === 0) {
          return $q.reject({ paid_user: false });
        }
      });
    }]
  })
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/plans-billings/plans-billings.routing.js
 ** module id = 370
 ** module chunks = 0
 **/